module.exports = __webpack_public_path__ + "1a6072d581d37a10f4ce2e2fe47a27a0.woff2";